module.exports = __webpack_public_path__ + "static/mini-map-966bb0ef43e5e6fc2e3ed1645ebe5b2a.svg";